import { useEffect, useState } from 'react';
import React from 'react';

import '../css/NavBar.css'
import ScrollableTabsButtonVisible from './Tabs';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { Button, Modal, List, ListItem, ListItemText, LinearProgress } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { useNavigate } from 'react-router-dom';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const MyModal = ({ tabs, open, handleClose, setTabs, setValue, value, theme }) => {
    const navigate = useNavigate()

    const handleTabClick = (index, target) => {
        setValue(index)
      navigate(target)
    };
  
    const handleAddTab = () => {
        const newTabs = [...tabs, { label: `Home`, target: '/' }];
        setTabs(newTabs);
      };
      
  const handleDeleteTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    setTabs(newTabs);

    // Adjust the value if the deleted tab was selected
    if (value === index) {
      setValue(Math.min(index, newTabs.length - 1));
      if (newTabs.length > 0) {
          
       navigate(newTabs[Math.min(index, newTabs.length - 1)].target);
      } else {
        handleAddTab()
        navigate('/'); // Navigate to the home page if there are no tabs left
      }
    }
  };

    return (
      <Modal open={open} onClose={handleClose}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%',height: '100%', boxShadow: 24, p: 4 }} className='modal-bg'>
          <div className='topBar'>
            <md-icon-button onClick={handleClose}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
            </md-icon-button>
            Tabs
            <div className='buttons'>
                <md-icon-button onClick={handleAddTab}>
                    
<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
                </md-icon-button>
            </div>
          </div>
          <List sx={{margin:2, maxHeight: '100%', overflowY: 'auto'}}>
            {tabs.map((tab, index) => (
              <ListItem key={index} 
              secondaryAction={
                <IconButton edge="end" aria-label="delete" sx={value === index ? {
                  background: 'var(--md-sys-color-primary)',
                  color: 'var(--md-sys-color-on-primary)'
                }: {
                  background:'var(--md-sys-color-surface)'
                }}
                onClick={() => handleDeleteTab(index)}>
                  <DeleteIcon />
                </IconButton>
              }
              sx={value === index ? {
                background: 'var(--md-sys-color-primary)',
                color: 'var(--md-sys-color-on-primary)',
                marginBottom: 1,
              }: {
                background:'var(--md-sys-color-surface)',
                marginBottom: 1,
              }}
              >
                <ListItemButton onClick={() => { handleTabClick(index, tab.target); handleClose(index)}}>
                    
                <ListItemText primary={tab.label}  />
                </ListItemButton>
                  
              </ListItem>
            ))}
          </List>
        </div>
      </Modal>
    );
  };
function NavBar({
    leftSideBar,
    setLeftSideBar,
    setRightSideBar,
    LogOut,
    rightSideBar,
    setColorScheme,
    tabs,
    setTabs,
    value,
    setValue,
    theme,
    colorScheme,
}) {
    
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

    const [isDarkMode, setIsDarkMode] = useState(false)
    useEffect(()=>{
        if(colorScheme === 'dark') {
            setIsDarkMode(true)
        }else {
            setIsDarkMode(false)
        }
    }, [colorScheme])
    useEffect(()=>{
        if(isDarkMode === true) {
            setColorScheme('dark')
        }else {
            setColorScheme('light')
        }
    }, [isDarkMode])

    const [showDarkThemeLoader, setShowDarkThemeLoader] = useState(false);
    
    function openDarkTheme() {
        
      setShowDarkThemeLoader(true)
  const timer = setTimeout(()=>{
      setShowDarkThemeLoader(false)
  }, 1000)
  return ()=>clearTimeout(timer)
  }
  const toggleDarkMode = (checked) => {
    setIsDarkMode(!checked)
  };

    
    const handleCheckboxChange = () => {
     // setLeftSideBar(!leftSideBar);
    };
    
    const handleRightSideBar = () => {
      //setRightSideBar(!rightSideBar);
    };
    return(
        <>
        <div className="nav">
            <div className='logo' style={{width: 'calc(100% - 350px)'}}>
            <div className='logo'>
                <input type="checkbox" checked={leftSideBar} onChange={handleCheckboxChange} id="checkbox1" className="checkbox1 visuallyHidden" />
                
                <svg
                  style={{opacity: 0}}
                    className={`ham hamRotate ham8 ${leftSideBar ? 'active' : ''}`}
                    viewBox="0 0 100 100"
                    width="55"
                    onClick={handleCheckboxChange}  
                >
                    <path
                            className="line top"
                            stroke="white"
                            d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
                    <path
                            className="line middle"
                            stroke="white"
                            d="m 30,50 h 40" />
                    <path
                            className="line bottom"
                            stroke="white"
                            d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
                </svg>
                <div className='logotext'>
                    donotes
                </div>
            </div>
            <ScrollableTabsButtonVisible setTabs={setTabs}  setValue={setValue} value={value} tabs={tabs} theme={theme} />
            </div>
            <div className='buttonGroup'>
                
    <div className='desktop-hide' style={{
      width: 25,
      height: 25,
      border: '2px solid var(--md-sys-color-primary)',
      borderRadius: 8,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 'small'
    }} onClick={handleOpenModal}>
        {tabs.length}
    </div>
                {/*<md-filled-tonal-button>
                    Search for tools
                    <svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                </md-filled-tonal-button>*/}
                <md-icon-button onClick={()=>{openDarkTheme(); toggleDarkMode(isDarkMode)}} disabled style={{opacity: 0}}>
                <DarkModeSwitch
                checked={!isDarkMode}
                moonColor='black'
                sunColor='white'
                size={25}
                />
                  </md-icon-button>
                  
                <md-icon-button onClick={handleRightSideBar} style={{opacity: 0}}>
<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="var(--md-sys-color-primary)"><path d="M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z"/></svg></md-icon-button>
                <md-icon-button style={{opacity: 0}} disabled onClick={LogOut}><FontAwesomeIcon icon={faArrowRightFromBracket} style={{fontSize: 'large'}}/></md-icon-button>
            
            
            </div>
        </div>
        <MyModal  setValue={setValue} value={value}  tabs={tabs} setTabs={setTabs} open={modalOpen} handleClose={handleCloseModal} />
   
        {showDarkThemeLoader && 
        <div class="loading-overlay">
            Switching theme...
            <div style={{
                width: 300,
                height: 20,
                marginTOp: 100
            }}>
                
                <LinearProgress />
            </div>
        </div>}
        </>
    )
}
export default NavBar;